/*
 * Map the design-system `StatusTone` vocabulary to Mantine palette colors.
 * Used by the Mantine-backed `StatusBadge` and `Alert` primitives so the whole
 * app keeps its tone semantics while rendering through Mantine defaults.
 */
import type { StatusTone } from "./status";

export const TONE_COLOR: Record<StatusTone, string> = {
  success: "green",
  warning: "yellow",
  danger: "red",
  info: "blue",
  neutral: "gray",
  attention: "orange",
};
